module.exports = __webpack_public_path__ + "img/shop-1.473f5f53.png";